import firebase from 'firebase';
var config = {
  apiKey: "AIzaSyBSuzE_H_p_VEb2itJlpoCNYp97fToG5cc",
  authDomain: "padel-44643.firebaseapp.com",
  databaseURL: "https://padel-44643.firebaseio.com",
  projectId: "padel-44643",
  storageBucket: "padel-44643.appspot.com",
  messagingSenderId: "683399965484"
};

// var config = {
//   apiKey: "AIzaSyDGgBP50SffMqvd_ALX7kWlsYH1ptIVEz0",
//   authDomain: "elevensports-a2c45.firebaseapp.com",
//   databaseURL: "https://elevensports-a2c45-default-rtdb.firebaseio.com",
//   projectId: "elevensports-a2c45",
//   storageBucket: "elevensports-a2c45.appspot.com",
//   messagingSenderId: "632373842740"
// };

const app = firebase.initializeApp(config);
const db = app.database();
export default db;
